import anime from 'animejs'
import emitter from '@utils/emitter'

export default {
  name: 'konami',

  ui: {
    text: '[js-konami-text]',
  },

  componentDidMount () {
    console.log('hey, funny seing you here.')
    console.log('how you doing?')
    console.log('hope you have a nice day.')

    this.ui.text.style.opacity = '0'
    this.ui.text.textContent = 'oh no...'

    // const KONAMI_KEYS = [38, 38, 40, 40, 37, 39, 37, 39, 66, 65]
    const KONAMI_KEYS = [
      'ArrowUp',
      'ArrowUp',
      'ArrowDown',
      'ArrowDown',
      'ArrowLeft',
      'ArrowRight',
      'ArrowLeft',
      'ArrowRight',
      'b',
      'a',
    ]

    this.hasKonami = false
    this.konamiIndex = 0

    document.body.addEventListener('keydown', (e) => {
      if (!this.hasKonami && e.key === KONAMI_KEYS[this.konamiIndex]) {
        this.konamiIndex += 1
        if (this.konamiIndex === KONAMI_KEYS.length) {
          this.hasKonami = true
          this.konamiIndex = 0
          this.triggerKonami()
        }
      } else {
        this.konamiIndex = 0
      }
    })
  },

  triggerKonami () {
    emitter.trigger('KONAMI')

    this.ui.text.textContent = 'oh no...'

    anime
      .timeline()
      .add(
        {
          targets: this.el,
          opacity: 1,
          duration: 500,
          easing: 'easeOutCubic',
        },
        0,
      )
      .add(
        {
          targets: this.ui.text,
          opacity: 1,
          duration: 1000,
          easing: 'easeOutCubic',
        },
        500,
      )
      .add(
        {
          targets: this.ui.text,
          opacity: 0,
          duration: 500,
          easing: 'easeOutCubic',
          complete: () => {
            this.ui.text.textContent = "it's a shreklipse..."
          },
        },
        '+=3000',
      )
      .add(
        {
          targets: this.ui.text,
          opacity: 1,
          duration: 1000,
          easing: 'easeOutCubic',
        },
        '+=500',
      )
      .add(
        {
          targets: this.el,
          opacity: 0,
          duration: 500,
          easing: 'easeOutCubic',
        },
        '+=5000',
      )
  },
}
